if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (!this.form) {
        return;
      }
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-drawer');
      this.productInfo = this.closest('product-info');
      this.submitButton = this.querySelector('[type="submit"]');
      this.submitButtonText = this.querySelector('[type="submit"] > span');
      this.qtyLimitMessage = this.querySelector('.product-form__quantity-message');

      this.qtyLimit = parseInt(this.submitButton.dataset.qtyLimit);
      this.qtyMessageString = this.submitButton.dataset.qtyMessageString;
      this.productId = parseInt(this.submitButton.dataset.productId);
      this.cartDrawerItems = document.querySelector('cart-drawer');
      if (this.qtyLimit > 0) this.cartDrawerListener();

      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      this.hideErrors = this.dataset.hideErrors === 'true';
      this.handleSwymWishlistButtonClick();

      if (this.productInfo) {
        // Updates variant if option is clicked before the form is fully loaded
        this.productInfo.querySelector('variant-radios.clicked')?.onVariantChange();

        // submit form if button is clicked before the form is fully loaded
        if (this.submitButton.classList.contains('loading')) {
          this.submitButton.classList.remove('loading');
          this.submitButton.ariaDisabled = false;
          this.onSubmitHandler();
        }
      }

      this.submitButton.classList.remove('js-loading');
    }

    async getCartData() {
      try {
        const response = await fetch('/cart.js', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const cartData = await response.json();
        return cartData;
      } catch (error) {
        console.error('Error fetching cart data:', error);
      }
    }

    handleSwymWishlistButtonClick() {
      const wishlistButton = this.querySelector(".swym-add-to-wishlist-view-product");
      wishlistButton?.addEventListener("click", (event) => {
        if (wishlistButton.classList.contains("swym-added")) {
          wishlistButton.classList.remove("animate--adding");
        } else {
          wishlistButton.classList.add("animate--adding");
        }
      });
    };

    async qtyLimitCheck() {
      let reachedQty = false;

      const getCartProductQty = (cartItems) => {
        const matchingCount = cartItems.reduce((count, item) => {
          if (item.product_id === this.productId) {
            return count + item.quantity;
          }
          return count;
        }, 0);

        return matchingCount;
      };

      const cartData = await this.getCartData();
      const cartItems = cartData.items;

      const currentCartQty = getCartProductQty(cartItems);
      if(this.qtyLimitMessage){
        if (currentCartQty >= this.qtyLimit) {
          this.qtyLimitMessage.textContent = this.qtyMessageString;
          this.submitButton.classList.add("disabled");
          this.submitButton.setAttribute('data-qty-message', this.qtyMessageString);
          reachedQty = true;
        } else {
          this.qtyLimitMessage.textContent = '';
          this.submitButton.classList.remove("disabled");
          this.submitButton.setAttribute('data-qty-message', '');
          reachedQty = false;
        }
      }

      return reachedQty;
    }

    cartDrawerListener() {
      const cartItems = document.querySelector('#CartDrawer .drawer__inner');

      const handleCartObserver = () => this.qtyLimitCheck();

      const cartItemsObserver = new MutationObserver(handleCartObserver);
      cartItemsObserver.observe(cartItems, {attributes : true, childList : true, subtree : true});
    }

    async onSubmitHandler(evt) {
      evt?.preventDefault();

      if (this.qtyLimit > 0) {
        const reachedQty = await this.qtyLimitCheck();

        if (reachedQty) return;
      }

      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      const formLocation = this.form.dataset.location || '';

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        try {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        } catch(error) {
          console.error(error)
          this.form.submit()
        }
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      let productGroup = this.closest('.product')?.querySelector('product-group');

      if(productGroup){

        let productGroupCurrent = productGroup.dataset.selectedType;
        if (productGroupCurrent && productGroupCurrent.includes(':')) {
          let productGroupCurrentItem = productGroupCurrent.split(":");
          let productGroupType = productGroupCurrentItem[0].trim();
          let productGroupData = productGroupCurrentItem[1].trim();

          formData.set(`[properties][${productGroupType}]`, productGroupData)
        }
      }

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickBuyDrawer = this.closest('quickbuy-drawer');
          if (quickBuyDrawer) {
            quickBuyDrawer.close();
          }
          this.cart.open('atc');

          let productTemplateData = this.querySelector('template')
          if (productTemplateData) {
            productTemplateData = productTemplateData.innerHTML;
            productTemplateData = JSON.parse(productTemplateData);
          }

          this.dispatchEvent(new CustomEvent('cart-item:added', {
            bubbles: true,
            detail: {
              action: 'add',
              location: formLocation,
              item: response,
              product: productTemplateData
            }
          }));
          this.updateCartIconBubble();
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');

          if (this.submitButton.dataset.qtyLimit && this.submitButton.dataset.qtyMessage) {
            this.submitButtonText.textContent = this.submitButton.dataset.qtyMessage;
            this.submitButton.classList.add("disabled");
          }

          this.qtyLimitCheck();
        });
    }

    updateCartIconBubble() {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const cartItemCount = cart.item_count;
          const cartIconBubbles = document.querySelectorAll('#cart-icon-bubble .cart-count-bubble span');

          if (!cartIconBubbles.length) return;

          cartIconBubbles.forEach((bubble) => {
            if (bubble.getAttribute('data-count') !== null) {
              bubble.setAttribute('data-count', cartItemCount);
            }
            bubble.textContent = bubble.textContent.replace(/\d+/, cartItemCount);
          })
        })
        .catch(e => {
          console.error('Error updating cart icon bubble:', e);
        });
    }

    handleErrorMessage(errorMessage = false) {

      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}